/**
 * AudioStreamPlayer parser for the linter's property surface plus the inherited Node base. A
 * missing value takes Godot's default, and a malformed number logs a warning and falls back to it.
 */
import { parseNode } from '../../node/parser';
import { parseAudioBase } from '../parseAudioBase';
export function parseAudioStreamPlayer(heading, properties) {
    const baseProps = parseNode(heading, properties);
    return {
        ...baseProps,
        ...parseAudioBase(properties, 'AudioStreamPlayer'),
    };
}
//# sourceMappingURL=parser.js.map